import { render, staticRenderFns } from "./ImportTransfers.vue?vue&type=template&id=0083d2b6"
import script from "./ImportTransfers.vue?vue&type=script&lang=js"
export * from "./ImportTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports